import styled from 'styled-components';
import BasicStats from 'challenge/common/BasicStats';
import Wra16A from 'dc/Wra16A';
import Wra16B from 'dc/Wra16B';
import { Typ30, Typ50 } from 'dc/Typ';

export const Wrapper = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Stats = styled(BasicStats)`
  margin-top: 32px;
`;

export const TitleWrapper = styled(Wra16A)`
  width: 100%;
  text-align: center;
`;

export const Title = styled(Typ50)`
  width: 100%;
  max-width: 500px;
  text-align: center;
`;

export const WrapperStdSideBtm = styled(Wra16B)`
  width: 100%;
  text-align: center;
`;

export const Tagline = styled(Typ30)`
  width: 100%;
  max-width: 500px;
  text-align: center;
  color: #607d8b;
`;
